/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SubjectMatterExpertKey { 
    /**
     * The user id of the Subject Matter Expert. This must be a fully qualified name as the value will be utilized to look up contact                   information in LDAP                
     */
    userId: string;
}
